<p-dialog
  [(visible)]="visible"
  [style]="{ width: '90vw', height: '90vh' }"
  [modal]="true"
  [blockScroll]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeModal()"
>
  <ng-template pTemplate="closeicon">
    <span class="closeicon pi pi-times"></span>
  </ng-template>
  <ng-template pTemplate="header">
    <div class="flex items-center">
      <div>
        <app-animal-current-category
          [animal]="animal"
        ></app-animal-current-category>
      </div>
      <div class="flex px-4 animal-name-headline font-bold">
        {{ animal?.displayName }}
      </div>
      <div class="flex items-center justify-center px-4">
        <img
          ngSrc="../../../../assets/images/icons/icon_key_green.svg"
          alt="key"
          height="34"
          width="37"
        />
        <p>
          @if (animal?.oldBookNumber) { {{ animal?.oldBookNumber }} }
          <span>({{ animal?.bookNumber }} )</span>
        </p>
      </div>
    </div>
  </ng-template>
  @if (animal) {
  <ng-template pTemplate="content">
    <form [formGroup]="formGroup">
      <p-accordion [multiple]="true" [value]="['0', '1', '2', '3', '4']">
        <div class="flex flex-row">
          <div class="flex-1">
            <p-accordion-panel value="0">
              <p-accordion-header>
                {{ 'animalEdit.general.basicData.headline' | transloco }}
              </p-accordion-header>
              <p-accordion-content>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <p-inputgroup>
                      <p-iftalabel>
                        
                        <p-select
                        id="animalCategory"
                        [options]="animalCategoryOptions"
                        optionLabel="name"
                        optionValue="value"
                        formControlName="category"
                        (onChange)="setCharacteristicOptions($event.value)"
                        appendTo="body"
                        />
                        <label for="animalType">
                          {{
                            'animalEdit.general.basicData.category' | transloco
                          }}
                          <span class="required">*</span>
                        </label>
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div>
                    <p-inputgroup>
                      <p-iftalabel>
                        <p-select
                        id="animalType"
                        [options]="animalTypeOptions"
                        optionLabel="name"
                        optionValue="value"
                        formControlName="type"
                        appendTo="body"
                        />
                        <label for="animalType">
                          {{ 'animalEdit.general.basicData.type' | transloco }}
                          <span class="required">*</span>
                        </label>
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div class="col-span-2">
                    <p-inputgroup>
                      <p-iftalabel>
                        <input
                        type="text"
                        pInputText
                        id="breed"
                        formControlName="breed"
                        />
                        <label for="breed">
                          {{
                            'animalEdit.general.specifications.breed'
                              | transloco
                          }}</label
                        >
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div class="col-span-2">
                    <p-inputgroup>
                      <p-iftalabel>
                        <input
                        type="text"
                        pInputText
                        id="name"
                        formControlName="name"
                        />
                        <label for="name">
                          {{ 'animalEdit.general.basicData.name' | transloco }}
                        </label>
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div>
                    <p-inputgroup>
                      <p-iftalabel>
                        <input
                        type="text"
                        pInputText
                        id="nameOld"
                        formControlName="nameOld"
                        />
                        <label for="nameOld">
                          {{
                            'animalEdit.general.basicData.nameOld' | transloco
                          }}
                        </label>
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div>
                    <p-inputgroup>
                      <p-iftalabel>
                        <input
                        type="text"
                        pInputText
                        id="nameNew"
                        formControlName="nameNew"
                        />
                        <label for="nameNew">
                          {{
                            'animalEdit.general.basicData.nameNew' | transloco
                          }}
                        </label>
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div class="col-span-2">
                    <app-mother-select
                      [mother]="mother"
                      [excludeAnimalId]="animal.id"
                      (motherSelected)="addMotherAnimal($event)"
                    ></app-mother-select>
                  </div>
                  <div>
                    <p-inputgroup>
                      <p-iftalabel>
                        
                        <p-select
                        id="gender"
                        [options]="genderOptions"
                        optionLabel="name"
                        optionValue="key"
                        formControlName="sex"
                        appendTo="body"
                        />
                        <label for="gender">
                          {{ 'animalEdit.general.basicData.sex' | transloco }}
                          <span class="required">*</span>
                        </label>
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>

                  <div class="flex gap-2 items-center justify-center">
                    <label for="castrated">
                      {{
                        'animalEdit.general.specialInformations.castrated'
                          | transloco
                      }}
                    </label>
                    <p-toggleswitch
                      formControlName="castrated"
                      id="castrated"
                      inputId="castrated"
                    />
                  </div>

                  <!-- Castrated Date: volle Breite, Picker + Clear rechts -->
                  <div class="flex gap-2 items-end">
                    <div class="flex-1">
                      <app-custom-date-picker
                        [label]="
                          'animalEdit.general.specialInformations.castratedDate'
                        "
                        [rawInput]="formGroup.get('castratedDate')?.value"
                        (valueChange)="
                          formGroup.get('castratedDate')?.setValue($event)
                        "
                      ></app-custom-date-picker>
                    </div>
                    @if (formGroup.get('castratedDate')?.value) {
                    <p-button
                      icon="pi pi-times"
                      [text]="true"
                      (click)="formGroup.get('castratedDate')?.setValue(null)"
                    />
                    }
                  </div>

                  <!-- Sterilized Date -->
                  <div class="flex gap-2 items-end">
                    <div class="flex-1">
                      <app-custom-date-picker
                        [label]="
                          'animalEdit.general.specialInformations.sterilizedDate'
                        "
                        [rawInput]="formGroup.get('sterilizedDate')?.value"
                        (valueChange)="
                          formGroup.get('sterilizedDate')?.setValue($event)
                        "
                      ></app-custom-date-picker>
                    </div>
                    @if (formGroup.get('sterilizedDate')?.value) {
                    <p-button
                      icon="pi pi-times"
                      [text]="true"
                      (click)="formGroup.get('sterilizedDate')?.setValue(null)"
                    />
                    }
                  </div>

                  <!-- Chemical Castrated Date -->
                  <div class="flex gap-2 items-end">
                    <div class="flex-1">
                      <app-custom-date-picker
                        [label]="
                          'animalEdit.general.specialInformations.chemicalCastratedDate'
                        "
                        [rawInput]="
                          formGroup.get('chemicalCastratedDate')?.value
                        "
                        (valueChange)="
                          formGroup
                            .get('chemicalCastratedDate')
                            ?.setValue($event)
                        "
                      ></app-custom-date-picker>
                    </div>
                    @if (formGroup.get('chemicalCastratedDate')?.value) {
                    <p-button
                      icon="pi pi-times"
                      [text]="true"
                      (click)="
                        formGroup.get('chemicalCastratedDate')?.setValue(null)
                      "
                    />
                    }
                  </div>

                  <!-- Castrated Note: volle Breite -->
                  <div >
                    <p-inputgroup>
                      <p-iftalabel>
                        <input
                          type="text"
                          pInputText
                          id="castratedNote"
                          formControlName="castratedNote"
                        />
                        <label for="castratedNote">
                          {{
                            'animalAdd.general.specialInformations.castratedNote'
                              | transloco
                          }}
                        </label>
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel value="1">
              <p-accordion-header>{{
                'animalEdit.general.specifications.headline' | transloco
              }}</p-accordion-header>
              <p-accordion-content>
                <div class="grid grid-cols-2 gap-2">
                  <div class="col-span-2">
                    <app-custom-date-picker
                      [label]="'animalEdit.general.specifications.birthday'"
                      [isApproximateYearInput]="true"
                      [isApproximate]="formGroup.get('birthApprox')?.value"
                      [isYearOnly]="formGroup.get('birthdayType')?.value"
                      [rawInput]="currentBirthday"
                      (valueChange)="onDelayedBirthdayChange($event)"
                      (approxChanged)="
                        formGroup.get('birthApprox')?.setValue($event)
                      "
                      (yearOnlyChanged)="onYearOnlyChanged($event)"
                    />
                  </div>
                  <div>
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="birthPlace">
                          {{
                            'animalEdit.general.specifications.birthPlace'
                              | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          pInputText
                          id="birthPlace"
                          formControlName="birthPlace"
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div>
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="coatType">
                          {{
                            'animalEdit.general.specifications.coatType'
                              | transloco
                          }}
                        </label>
                        <p-multiSelect
                          id="coatType"
                          [options]="coatTypeOptions"
                          optionLabel="name"
                          optionValue="value"
                          formControlName="coatType"
                          [style]="{ width: '100%' }"
                          [panelStyle]="{ width: '100%' }"
                          appendTo="body"
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div>
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="coatColor">
                          {{
                            'animalEdit.general.specifications.coatColor'
                              | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          pInputText
                          id="coatColor"
                          formControlName="coatColor"
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div>
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="badge">
                          {{
                            'animalEdit.general.specifications.badge'
                              | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          pInputText
                          id="badge"
                          formControlName="badge"
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div>
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="specialNotice">
                          {{
                            'animalEdit.general.specifications.specialNotice'
                              | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          pInputText
                          id="specialNotice"
                          formControlName="specialNotice"
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div>
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="size">
                          {{
                            'animalEdit.general.specifications.size' | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          pInputText
                          id="size"
                          formControlName="size"
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div>
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="weight">
                          {{
                            'animalEdit.general.specifications.weight'
                              | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          pInputText
                          id="weight"
                          [value]="weightInput"
                          (input)="onWeightInput($event)"
                          maxlength="10"
                          placeholder="z.B. 12,345"
                          autocomplete="off"
                        />
                      </p-iftalabel>
                      <p-inputgroup-addon>kg</p-inputgroup-addon>
                    </p-inputgroup>
                    <small *ngIf="weightInputInvalid" class="p-error"
                      >Bitte im Format 0,000 eingeben</small
                    >
                  </div>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
          </div>
          <div class="flex-1">
            <p-accordion-panel value="2">
              <p-accordion-header>{{
                'animalEdit.general.numbers.headline' | transloco
              }}</p-accordion-header>
              <p-accordion-content>
                <div class="grid grid-cols-2 gap-2">
                  <div class="col-span-2">
                    <label for="oldBookNumber_0">
                      {{
                        'animalAdd.general.basicData.oldBookNumber' | transloco
                      }}
                    </label>
                    <p-button
                      icon="pi pi-plus"
                      class="p-button-text p-button-sm"
                      [text]="true"
                      (click)="addOldBookNumber()"
                    />
                    <div
                      formArrayName="oldBookNumberList"
                      class="flex flex-col"
                    >
                      @for (ctrl of oldBookNumberControlsReversed; track ctrl;
                      let i = $index) {
                      <div class="mb-1 flex items-center">
                        <p-inputgroup>
                          <input
                            pInputText
                            type="text"
                            class="rounded-r-none!"
                            [formControl]="ctrl"
                            [id]="'oldBookNumber_' + i"
                            [attr.name]="'oldBookNumber_' + i"
                            spellcheck="false"
                            autocomplete="off"
                          />
                        </p-inputgroup>

                        <p-button
                          icon="pi pi-trash"
                          styleClass="ml-2 p-button-sm"
                          [rounded]="true"
                          severity="danger"
                          (click)="removeOldBookNumberControl(ctrl)"
                        />
                      </div>
                      }
                    </div>
                  </div>
                  <div class="col-span-2">
                    <div class="flex gap-2 items-center">
                      <label for="transponderNumber_0">
                        {{
                          'animalEdit.general.numbers.transponderNumber'
                            | transloco
                        }}
                      </label>
                      <p-button
                        icon="pi pi-plus"
                        class="p-button-text p-button-sm"
                        [text]="true"
                        (click)="addTransponderNumber()"
                      />
                    </div>
                    <div
                      formArrayName="transponderNumber"
                      class="flex flex-col"
                    >
                      @for (ctrl of transponderNumbers.controls; track ctrl; let
                      i = $index) {
                      <div class="mb-1 flex items-center">
                        <p-inputgroup>
                          @if (transponderNumbers.length > 1) {
                          <p-inputgroup-addon>
                            <p-button
                              icon="pi pi-trash"
                              severity="danger"
                              [text]="true"
                              (click)="removeTransponderNumber(i)"
                            />
                          </p-inputgroup-addon>
                          }
                          <input
                            type="text"
                            pInputText
                            formControlName="{{ i }}"
                            [id]="'transponderNumber_' + i"
                            [attr.name]="'transponderNumber_' + i"
                            spellcheck="false"
                            autocomplete="off"
                          />
                          <app-barcode-scanner
                            [bindTo]="'transponderNumber_' + i"
                            (barcodeScanned)="
                              handleBarcodeTransponderScanned($event)
                            "
                          />
                        </p-inputgroup>
                      </div>
                      }
                    </div>
                  </div>
                  <div>
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="lifeNumber">
                          {{
                            'animalEdit.general.numbers.lifeNumber' | transloco
                          }}
                        </label>

                        <input
                          type="text"
                          pInputText
                          id="lifeNumber"
                          formControlName="lifeNumber"
                        />
                      </p-iftalabel>
                      <p-inputgroup-addon>
                        <app-barcode-scanner
                          [bindTo]="'lifeNumber'"
                          (barcodeScanned)="handleBarcodeScanned($event)"
                        ></app-barcode-scanner>
                      </p-inputgroup-addon>
                    </p-inputgroup>
                  </div>
                  <div>
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="petPassportNumber">
                          {{
                            'animalAdd.general.numbers.petPassportNumber'
                              | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          pInputText
                          id="petPassportNumber"
                          formControlName="petPassportNumber"
                        />
                      </p-iftalabel>
                      <p-inputgroup-addon>
                        <app-barcode-scanner
                          [bindTo]="'petPassportNumber'"
                          (barcodeScanned)="handleBarcodeScanned($event)"
                        />
                      </p-inputgroup-addon>
                    </p-inputgroup>
                  </div>
                  <div>
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="equinePassportNumber">
                          {{
                            'animalAdd.general.numbers.equinePassportNumber'
                              | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          pInputText
                          id="equinePassportNumber"
                          formControlName="equinePassportNumber"
                        />
                      </p-iftalabel>
                      <p-inputgroup-addon>
                        <app-barcode-scanner
                          [bindTo]="'equinePassportNumber'"
                          (barcodeScanned)="handleBarcodeScanned($event)"
                        />
                      </p-inputgroup-addon>
                    </p-inputgroup>
                  </div>
                  <div>
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="ringNumber">
                          {{
                            'animalEdit.general.numbers.ringNumber' | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          pInputText
                          id="ringNumber"
                          formControlName="ringNumber"
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div>
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="earTag">
                          {{
                            'animalEdit.general.numbers.earTagNumber'
                              | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          pInputText
                          id="earTag"
                          formControlName="earTag"
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div>
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="tattoo">
                          {{ 'animalEdit.general.numbers.tattoo' | transloco }}
                        </label>
                        <input
                          type="text"
                          pInputText
                          id="tattoo"
                          formControlName="tattoo"
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div class="col-span-2">
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="tattooLocation">
                          {{
                            'animalEdit.general.numbers.tattooLocation'
                              | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          pInputText
                          id="tattooLocation"
                          formControlName="tattooLocation"
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel value="3">
              <p-accordion-header>{{
                'animalEdit.general.specialInformations.headline' | transloco
              }}</p-accordion-header>
              <p-accordion-content>
                <div class="grid gap-2">
                  <div class="col-span-12">
                    <app-editor-field
                      formControlName="specialInformation"
                      id="specialInformation"
                    />
                  </div>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
          </div>
        </div>
        <div class="flex flex-row">
          <div class="flex-1">
            <p-accordion-panel value="4">
              <p-accordion-header>
                {{
                  'animalEdit.general.websiteInformations.headline' | transloco
                }}
              </p-accordion-header>
              <p-accordion-content>
                <div class="grid gap-2">
                  <div class="col-span-12">
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="externalShortDescription">
                          {{
                            'animalEdit.general.websiteInformations.externalShortDescription'
                              | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          pInputText
                          id="externalShortDescription"
                          formControlName="externalShortDescription"
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div class="col-span-12">
                    <app-editor-field
                      formControlName="externalDescription"
                      id="externalDescription"
                      [style]="{ height: '220px' }"
                    />
                  </div>
                  <div class="col-span-6">
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="internalDetails">
                          {{
                            'animalEdit.general.specialInformations.characteristics.headline'
                              | transloco
                          }}
                          ({{
                            'animalEdit.general.specialInformations.characteristics.internal'
                              | transloco
                          }})
                        </label>
                        <p-multiSelect
                          class="p-inputdropdown-sm w-full"
                          id="internalDetails"
                          [options]="characteristicsOptions"
                          optionLabel="name"
                          optionValue="value"
                          formControlName="internalDetails"
                          [style]="{ width: '400px' }"
                          [panelStyle]="{ width: '400px' }"
                          appendTo="body"
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div class="col-span-6">
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="externalDescription">
                          {{
                            'animalEdit.general.specialInformations.characteristics.headline'
                              | transloco
                          }}
                          ({{
                            'animalEdit.general.specialInformations.characteristics.external'
                              | transloco
                          }})
                        </label>
                        <p-multiSelect
                          class="p-inputdropdown-sm w-full"
                          id="externalDetails"
                          [options]="characteristicsOptions"
                          optionLabel="name"
                          optionValue="value"
                          formControlName="externalDetails"
                          [style]="{ width: '400px' }"
                          [panelStyle]="{ width: '400px' }"
                          appendTo="body"
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div class="col-span-12">
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="websiteMetaDescription">
                          {{
                            'animalAdd.general.websiteInformations.websiteMetaDescription'
                              | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          pInputText
                          id="websiteMetaDescription"
                          formControlName="websiteMetaDescription"
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div class="col-span-12">
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="websiteMetaTitle">
                          {{
                            'animalAdd.general.websiteInformations.websiteMetaTitle'
                              | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          pInputText
                          id="websiteMetaTitle"
                          formControlName="websiteMetaTitle"
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
          </div>
        </div>
      </p-accordion>
    </form>
  </ng-template>
  }
  <ng-template pTemplate="footer">
    <div class="flex gap-2 items-center w-full">
      <div class="flex-1 items-center">
        <span class="required"
          >* {{ 'animalEdit.general.required' | transloco }}</span
        >
      </div>
      <div class="flex gap-2">
        <p-button
          (click)="closeModal()"
          icon="pi pi-times"
          [text]="true"
          label="{{ 'modal.cancel' | transloco }}"
        />
        <p-button
          (click)="saveChanges()"
          [disabled]="formGroup.invalid"
          icon="pi pi-save"
          label="{{ 'modal.save' | transloco }}"
        />
      </div>
    </div>
  </ng-template>
</p-dialog>

